module.exports = __webpack_public_path__ + "img/paint22.f6913501.png";